import { useState } from 'react';

export default function Consult({ go }) {
  const [form, setForm] = useState({ name:'', phone:'', email:'', care:'Full-time nanny', age:'Infant (0–1)', msg:'', type:'family' });
  const [sent, setSent] = useState(false);

  return (
    <div style={{ minHeight:'100vh' }}>
      <style>{`
        .consult-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 4rem; align-items: start; }
        .form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; margin-bottom: 1rem; }
        @media (max-width: 768px) {
          .consult-grid { grid-template-columns: 1fr; gap: 2rem; }
          .form-row { grid-template-columns: 1fr; }
        }
      `}</style>
      <div style={{ background:'var(--teal-deeper)', padding:'60px 1.5rem' }}>
        <div className="container">
          <div className="consult-grid">
            <div>
              <div style={{ fontSize:12, fontWeight:700, letterSpacing:2, color:'var(--teal-mid)', textTransform:'uppercase', marginBottom:12 }}>Get in touch</div>
              <h2 style={{ fontFamily:"'DM Serif Display',serif", fontSize:'clamp(26px,4vw,48px)', color:'white', lineHeight:1.15, marginBottom:16 }}>Book your free consultation</h2>
              <p style={{ fontSize:15, color:'rgba(255,255,255,.7)', lineHeight:1.75, marginBottom:'2rem' }}>Tell us what your family needs — we'll find the right match for your family.</p>
              <div style={{ display:'flex', flexDirection:'column', gap:'1rem' }}>
                {[['📞','Free 15-minute consult','Talk directly with Ebere about your childcare needs, schedule, and any special requirements. No obligation.'],['❤️','Join as a caregiver','Experienced nanny or support worker? Apply to join the Tinytrust network.']].map(([i,t,d]) => (
                  <div key={t} style={{ background:'rgba(255,255,255,.08)', border:'1px solid rgba(255,255,255,.15)', borderRadius:12, padding:'1rem 1.25rem', display:'flex', gap:'1rem', alignItems:'flex-start' }}>
                    <span style={{ fontSize:20, flexShrink:0 }}>{i}</span>
                    <div>
                      <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:4, flexWrap:'wrap' }}>
                        <span style={{ fontSize:14, fontWeight:600, color:'white' }}>{t}</span>
                      </div>
                      <p style={{ fontSize:13, color:'rgba(255,255,255,.6)', lineHeight:1.6 }}>{d}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div style={{ marginTop:'1.5rem', fontSize:13, color:'rgba(255,255,255,.5)', lineHeight:1.8 }}>
                <div>📍 Calgary, Alberta, Canada</div>
                <div>🪪 Licence No: TN28080273</div>
              </div>
            </div>

            <div style={{ background:'white', borderRadius:20, padding:'1.75rem' }}>
              {sent ? (
                <div style={{ textAlign:'center', padding:'2.5rem 1rem' }} className="fi">
                  <div style={{ fontSize:52, marginBottom:16 }}>🎉</div>
                  <h3 style={{ fontFamily:"'DM Serif Display',serif", fontSize:26, color:'var(--teal-deeper)', marginBottom:12 }}>Message received!</h3>
                  <p style={{ fontSize:15, color:'var(--text-mid)', marginBottom:28 }}>Thank you, <strong>{form.name}</strong>. Ebere will reach out within 24 hours.</p>
                  <button className="btn-primary" onClick={() => { setSent(false); setForm({ name:'',phone:'',email:'',care:'Full-time nanny',age:'Infant (0–1)',msg:'',type:'family' }); }}>Send another message</button>
                </div>
              ) : (
                <>
                  <h4 style={{ fontFamily:"'DM Serif Display',serif", fontSize:22, color:'var(--teal-deeper)', marginBottom:'1.25rem' }}>Send us a message</h4>
                  <div className="form-row">
                    <div><label>Your name</label><input placeholder="e.g. Jane Smith" value={form.name} onChange={e=>setForm({...form,name:e.target.value})}/></div>
                    <div><label>Phone number</label><input placeholder="e.g. 403-555-0100" value={form.phone} onChange={e=>setForm({...form,phone:e.target.value})}/></div>
                  </div>
                  <div style={{ marginBottom:'1rem' }}><label>Email address</label><input type="email" placeholder="your@email.com" value={form.email} onChange={e=>setForm({...form,email:e.target.value})}/></div>
                  <div className="form-row">
                    <div>
                      <label>Type of care needed</label>
                      <select value={form.care} onChange={e=>setForm({...form,care:e.target.value})}>
                        {['Full-time nanny','Part-time nanny','Overnight care','Special needs support','After-school care','Live-in nanny','Join as caregiver'].map(o=><option key={o}>{o}</option>)}
                      </select>
                    </div>
                    <div>
                      <label>Child's age</label>
                      <select value={form.age} onChange={e=>setForm({...form,age:e.target.value})}>
                        {['Infant (0–1)','Toddler (1–3)','Preschool (3–5)','School age (5–12)','Teen (12+)','Multiple ages','N/A — caregiver'].map(o=><option key={o}>{o}</option>)}
                      </select>
                    </div>
                  </div>
                  <div style={{ marginBottom:'1rem' }}><label>Tell us more</label><textarea rows={3} placeholder="Describe your schedule, any special requirements, your neighbourhood..." value={form.msg} onChange={e=>setForm({...form,msg:e.target.value})} style={{ resize:'vertical', minHeight:80 }}/></div>
                  <p style={{ fontSize:11, color:'var(--text-light)', marginBottom:'1rem' }}>Your information is protected — Alberta PIPA compliant.</p>
                  <button className="btn-primary" style={{ width:'100%', padding:14, fontSize:15 }} disabled={!form.name||!form.email||!form.msg} onClick={() => setSent(true)}>Send message →</button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}